/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import useStyles from './coupon-marketplace-header-style'
import CrossIcon from '../../../../assets/icons/icon_cross.svg'
import LeftArrowIcon from '../../../../assets/icons/icon_left_arrow.svg'

const CouponMarketplaceHeaderView = ({
  title,
  withBackButton,
  onBack,
  onCloseDetail,
}) => {
  const styles = useStyles()
  return (
    <div className={styles.header}>
      {withBackButton ? (
        <div
          className={styles.backButton}
          onClick={onBack}
        >
          <img
            alt="close"
            className={styles.cross}
            src={LeftArrowIcon}
          />
        </div>
      ) : (
        <div className={styles.backButton} />
      )}

      <h4 className={styles.titleHeaderDetail}>{title}</h4>
      <div
        className={styles.closeButton}
        onClick={onCloseDetail}
      >
        <img alt="close" className={styles.cross} src={CrossIcon} />
      </div>
    </div>
  )
}

export default CouponMarketplaceHeaderView
